import React, {
  useEffect, useState
} from "react";
import { useLocation, useNavigate } from "react-router";
import {
  BOOKING,
  // FARE,
  // RATES
} from "../../config/constants/api";
import {
  Col,
  Steps,
  Row,
  Card, Spin
} from "antd";
import { AiFillEnvironment } from "react-icons/ai";
import { useSelector } from "react-redux";
import DashbordSidebar from "../../components/DashboardSidebar";
import { FaArrowLeftLong } from "react-icons/fa6";
import { extractTime } from "../../config/helpers";

import { Get } from "../../config/api";

const { Step } = Steps;
const RideDetails = ({ status }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const data = location.state?.data;
  const id = location.state?.id;
  const [data, setData] = useState();
  // const [latestRates, setLatestRates] = useState(null);
  // const [latestFares, setLatestFares] = useState(null);
  // const [pricing, setPricing] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      getBookingDetails();
      // getAllLatestFares();
      // getAllLatestRates();
    }
    // eslint-disable-next-line
  }, []);
  // const getPerMileRate = (serviceType) => {
  //   if (latestFares) {
  //     let service = latestFares.find((fare) => fare._id === serviceType);
  //     return service?.fare;
  //   }
  // };
  const getBookingDetails = async () => {
    Get(BOOKING.getbooking + id, token)
      .then((response) => {
        if (response?.status) {
          setData(response?.data?.booking);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  // const getHourlyRate = (serviceType) => {
  //   if(serviceType){
  //     let capitalizedServiceType = serviceType.charAt(0).toUpperCase() + serviceType.slice(1).toLowerCase();
  //     if (latestRates) {
  //       let rate = latestRates.find((rate) => rate._id === capitalizedServiceType);
  //       return rate?.rate;
  //     }
  //   }
  // };
  // const getRushHoursRate = (serviceType) => {
  //   if (latestRates) {
  //     let rate = latestRates.find((rate) => rate._id === serviceType);
  //     return rate?.rushHourRate;
  //   }
  // };
  // const getRushHoursRate = (serviceType) => {
  //   if (latestRates) {
  //     let rate = latestRates.find((rate) => rate._id === serviceType);
  //     return rate?.rate * rate?.rushHourMultiple;
  //   }
  // };

  // const getAllLatestFares = () => {
  //   Get(FARE.getAllLatestFares, token)
  //     .then((response) => {
  //       if (response?.status) {
  //         setLatestFares(response?.data?.latestFares);
  //         // setPricing(response?.data?.pricing);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // };
  // const getAllLatestRates = () => {
  //   Get(RATES.getAllLatestRates, token)
  //     .then((response) => {
  //       if (response?.status) {
  //         setLatestRates(response?.data);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // };
  // const getTotalBeforeGratuity = () => {
  //   // in this function we will add rush hours rate because graturity also depends on rush hours so we can make Total Amount same as paid amount
  //   if (data) {
  //     return (
  //       getHourlyRate(data?.serviceType) * data?.duration +
  //       data?.extraMilesRate +
  //       data?.extraHoursRate +
  //       (data?.rushHours
  //         ? data?.rushHours * getRushHoursRate(data?.serviceType) -
  //           getHourlyRate(data?.serviceType) * data?.rushHours
  //         : 0) +
  //       (data?.initialMileage
  //         *
  //           getPerMileRate(
  //             data?.serviceType.charAt(0).toUpperCase() +
  //               data?.serviceType.slice(1).toLowerCase()
  //           ))
  //     );
  //   }
  // };
  // const getTotalBeforeGratuity = () => {
  //   if (data) {
  //     if (data?.type === "Subscription") {
  //       return (
  //         getHourlyRate(data?.serviceType) *
  //           (data?.finalDuration > 8 ? data?.finalDuration - 8 : 0) +
  //         (data?.rushHours
  //           ? data?.rushHours * getRushHoursRate(data?.serviceType) -
  //             getHourlyRate(data?.serviceType) * data?.rushHours
  //           : 0) +
  //         data?.finalMileage *
  //           getPerMileRate(
  //             data?.serviceType.charAt(0).toUpperCase() +
  //               data?.serviceType.slice(1).toLowerCase()
  //           )
  //       );
  //     } else {
  //       return (
  //         getHourlyRate(data?.serviceType) * data?.finalDuration +
  //         (data?.rushHours
  //           ? data?.rushHours * getRushHoursRate(data?.serviceType) -
  //             getHourlyRate(data?.serviceType) * data?.rushHours
  //           : 0) +
  //         data?.finalMileage *
  //           getPerMileRate(
  //             data?.serviceType.charAt(0).toUpperCase() +
  //               data?.serviceType.slice(1).toLowerCase()
  //           )
  //       );
  //     }
  //   }
  //   else{
  //     return
  //   }
  // };
  // function formatDuration(totalDuration) {
  //   if(totalDuration){

  //     const totalMinutes = Math.round(totalDuration * 60);
  //     const hours = Math.floor(totalMinutes / 60);
  //     const minutes = totalMinutes % 60;
      
  //     if (hours === 0) {
  //     return `${minutes} mins`;
  //   } else if (minutes === 0) {
  //     return `${hours} hour${hours > 1 ? 's' : ''}`;
  //   } else {
  //     return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} mins`;
  //   }
  // }else{
  //   return 0;
  // }
  // }
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              {data ?  (<Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div
                      className="about-us-section"
                      style={{ justifyContent: "center" }}
                    >
                      <div className="bg-paren" style={{ width: "100%" }}>
                        <Card
                          className="orderDetails"
                          style={{ padding: "20px 0" }}
                        >
                          <Row
                            style={{
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            <Col lg={24} xs={24}>
                              <div class="arrow-box">
                                <FaArrowLeftLong
                                  className="arrow"
                                  onClick={() =>
                                    navigate("/ride", { index: "3" })
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row gutter={[16, 16]}>
                            <Col
                              lg={24}
                              md={24}
                              xs={24}
                              style={{
                                textAlign: "end",
                                marginBottom: "10px",
                              }}
                            >
                              <Row gutter={[16, 16]} justify={"center"}>
                                <div
                                  id="map"
                                  style={{
                                    // height: "350px",
                                    width: "100%",
                                    zIndex: "1",
                                    position: "relative",
                                  }}
                                >
                                  <Col
                                    lg={24}
                                    md={24}
                                    xs={24}
                                    style={{
                                      textAlign: "end",
                                      zIndex: 999,
                                      position: "relative",
                                    }}
                                  >
                                    <div className="pet-name-pic">
                                      <div>
                                        {/* <h6 className="f-16-black">
                                          Total Charges: ${data?.totalCharges}
                                        </h6> */}
                                        <h6 className="f-16-black">
                                          Time: {extractTime(data?.time)}
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    lg={24}
                                    md={24}
                                    xs={24}
                                    style={{
                                      textAlign: "center",
                                      zIndex: 999,
                                      position: "relative",
                                    }}
                                  >
                                    {/* <Image
                                      src={UPLOADS_URL + data?.user?.image}
                                      alt=""
                                      className="img-fluid"
                                      style={{
                                        maxWidth: "220px",
                                        maxHeight: "220px",
                                      }}
                                      preview={false}
                                    /> */}
                                    {data?.user?.firstName && <h5>
                                      {data?.user?.firstName +
                                        " " +
                                        data?.user?.lastName}
                                    </h5>}
                                  </Col>
                                </div>

                                {/* <Col lg={12} md={20} xs={24}>
                                <div className="border border-gray-300 py-4 px-4 pay-slip for-text-left">
                                        <h4 className="font-tavi text-[20px] text-black mt-2">
                                          Hourly Service in Manhattan
                                        </h4>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          <span className="text-[#000] font-black">
                                            Vehicle Type:
                                          </span>{" "}
                                        {data?.serviceType} Luxury
                                        </p>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          <span className="text-[#000] font-black">
                                            {" "}
                                            Final Booking Duration:
                                          </span>{" "}
                                          {formatDuration(
                                            data?.finalDuration
                                          )}{" "}
                                        </p>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          <span className="text-[#000] font-black">
                                            {" "}
                                            Final Mileage:
                                          </span>{" "}
                                        {data?.finalMileage} miles
                                        </p>

                                        <Divider className="my-2" />
                                        <h4 className="font-tavi text-[20px] text-black mt-2">
                                          Pricing Breakdown:
                                        </h4>
                                      {data?.type !== "Subscription" && (
                                          <>
                                            <span className="text-[#000] font-semibold pt-2">
                                            Duration Rate: $
                                              {getHourlyRate(
                                                data?.serviceType
                                              )}{" "}
                                              per hour
                                            </span>
                                            <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                              Total for{" "}
                                              {formatDuration(
                                                data?.finalDuration
                                              )}{" "}
                                              :{" "}
                                              {formatDuration(
                                                data?.finalDuration
                                              )}{" "}
                                              × $
                                              {getHourlyRate(
                                                data?.serviceType
                                              )}
                                              /hour = $
                                              {(getHourlyRate(
                                                data?.serviceType
                                              ) * data?.finalDuration).toFixed(2)}
                                              /
                                            {data?.finalDuration.toFixed(
                                                2
                                              )}
                                              hrs
                                            </p>
                                          </>
                                        )}
                                        <>
                                          <span className="text-[#000] font-semibold pt-2">
                                            Mileage Fee:
                                          </span>
                                          <div>
                                            <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                            {data?.serviceType} Luxury: $
                                              {getPerMileRate(
                                                data?.serviceType
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  data?.serviceType
                                                    .slice(1)
                                                    .toLowerCase()
                                              )}{" "}
                                              per mile
                                            </p>
                                            <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                              Total for {data?.finalMileage}{" "}
                                              miles : {data?.finalMileage}{" "}
                                              miles × ${" "}
                                              {getPerMileRate(
                                                data?.serviceType
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  data?.serviceType
                                                    .slice(1)
                                                    .toLowerCase()
                                              )}
                                              /mile = $
                                            {data?.finalMileage *
                                                getPerMileRate(
                                                  data?.serviceType
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    data?.serviceType
                                                      .slice(1)
                                                      .toLowerCase()
                                                )}
                                            </p>
                                          </div>
                                        </>
                                        <p className="text-[#000]  pt-1">
                                          Booking Fee: ${pricing?.bookingFee}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Service Fee: ${pricing?.serviceFee}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Total before Gratuity :
                                        {data?.type !== "Subscription" ? (
                                            <span style={{ margin: "0 3px" }}>
                                              $
                                              {(getHourlyRate(
                                                data?.serviceType
                                              ) * data?.finalDuration).toFixed(2)}
                                              (hourly)
                                            </span>
                                          ) : (
                                            <span style={{ margin: "0 3px" }}>
                                              $
                                            {data?.finalDuration > 8
                                                ? (data?.finalDuration - 8) *
                                                  getHourlyRate(
                                                    data?.serviceType
                                                  )
                                                : 0}
                                              (Extra Hours Rate)
                                            </span>
                                          )}
                                          + $
                                        {data?.finalMileage *
                                            getPerMileRate(
                                              data?.serviceType
                                                .charAt(0)
                                                .toUpperCase() +
                                                data?.serviceType
                                                  .slice(1)
                                                  .toLowerCase()
                                            )}
                                          (mileage) + $
                                        {data?.rushHours
                                            ? data?.rushHours *
                                                getRushHoursRate(
                                                  data?.serviceType
                                                ) -
                                              getHourlyRate(
                                                data?.serviceType
                                              ) *
                                                data?.rushHours
                                            : 0}
                                          (Rush hour fee) = $
                                          {getTotalBeforeGratuity().toFixed(2)}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Gratuity: 20% x $
                                          {getTotalBeforeGratuity().toFixed(2)} = $
                                        {data?.gratuityAmount.toFixed(2)}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Tolls Charges : $
                                        {data?.tolls ? data?.tolls : 0}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Surcharge : $
                                        {data?.surcharge
                                            ? data?.surcharge
                                            : 0}
                                        </p>
                                        <p className="text-[#000]  pt-1">
                                          Rush hour fee : $
                                        {data?.rushHours
                                            ? data?.rushHours *
                                                getRushHoursRate(
                                                  data?.serviceType
                                                ) -
                                              getHourlyRate(
                                                data?.serviceType
                                              ) *
                                                data?.rushHours
                                            : 0}
                                        </p>
                                        <div>
                                          <span className="font-bold">
                                            Total Amount{" "}
                                          </span>{" "}
                                          :{" "}
                                           {data?.type !== "Subscription" ? (
                                            <>
                                              Hourly Rate (
                                              {(getHourlyRate(
                                                data?.serviceType
                                              ) * data?.finalDuration).toFixed(2)}
                                              )
                                            </>
                                          ) : (
                                            <>
                                              Extra Hours Rate (
                                            {data?.finalDuration > 8
                                                ? (data?.finalDuration - 8) *
                                                  getHourlyRate(
                                                    data?.serviceType
                                                  )
                                                : 0}
                                              )
                                            </>
                                          )}{" "}
                                          + Mileage Fee (
                                        {data?.finalMileage *
                                            getPerMileRate(
                                              data?.serviceType
                                                .charAt(0)
                                                .toUpperCase() +
                                                data?.serviceType
                                                  .slice(1)
                                                  .toLowerCase()
                                            )}
                                          ) + Gratuity(
                                        {data?.gratuityAmount.toFixed(2)})
                                          + Surcharge fee(
                                        {data?.surcharge
                                            ? data?.surcharge
                                            : 0}
                                          ) + Tolls (
                                        {data?.tolls ? data?.tolls : 0})
                                          + Rush Hour Fee(
                                        {data?.rushHours
                                            ? data?.rushHours *
                                                getRushHoursRate(
                                                  data?.serviceType
                                                ) -
                                              getHourlyRate(
                                                data?.serviceType
                                              ) *
                                                data?.rushHours
                                            : 0}
                                          ) + Booking Fee({pricing?.bookingFee})
                                          + Service Fee({pricing?.serviceFee}) =
                                          <span className="font-bold">
                                           {" "} ${data?.totalCharges.toFixed(2)}
                                          </span>
                                        </div>

                                        <Divider className="my-2" />
                                        <p className="text-[#000] font-bold pt-2 to-pay">
                                          Paid Amount: $
                                        {data?.totalCharges.toFixed(2)}
                                        </p>
                                      </div>
                                </Col> */}

                                <Col lg={12} md={20} xs={24}>
                                  <Steps
                                    direction="vertical"
                                    size="small"
                                    current={0}
                                    className="mb-1"
                                    style={{
                                      padding: "18px 0",
                                      backgroundColor: "#e7e7e7",
                                      borderRadius: "20px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <Step
                                      title="Pickup Location"
                                      icon={
                                        <AiFillEnvironment
                                          style={{ color: "#bd8230" }}
                                        />
                                      }
                                      description={
                                        data?.pickupLocation?.address
                                      }
                                      // description={
                                      //   ride?.pickupLocation?.address
                                      // }
                                    />
                                    <Step
                                      title="Destination"
                                      icon={<AiFillEnvironment />}
                                      description={
                                        data?.dropoffLocation?.address
                                          ? data?.dropoffLocation?.address
                                          : "Unknown"
                                      }
                                      // description={
                                      //   ride?.dropoffLocation?.address
                                      // }
                                    />
                                  </Steps>
                                </Col>
                              </Row>
                              <Row>
                                {data?.notes && (
                                  <Col xs={22} md={24} lg={20} xxl={12}>
                                    <div className="">
                                      <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1 ">
                                        Additional Notes
                                      </h5>
                                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                        {data?.notes}
                                      </p>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          </Row>
                        </Card>
                      </div>

                      {/* </Badge.Ribbon> */}
                    </div>
                  </section>
                </div>
              </Col>) :(<Col xs={24} md={24} lg={24} xl={24}><Spin /></Col>)}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RideDetails;
